import * as React from 'react'

interface IPageLayout {
	children: React.ReactNode
	isSticky: boolean
}

const PageLayout: React.FC<IPageLayout> = ({ children, isSticky }) => {
	return (
		<div className='pb-8 md:pb-24'>
			{children}
		</div>
	)
}

export default PageLayout
